import * as React from 'react'
import { Heading, Indent, Text, TextType } from 'LibNeo'
import { WrapperStyled } from './styled'

interface ComponentState {
	hasError?: boolean
	error?: Error | null
}
interface ComponentProps {
	children?: React.ReactNode
}

export const ErrorBoundary =
	<Props extends ComponentProps>(errorMessage?: string): any =>
	(WrappedComponent: React.ComponentType<Props>) =>
		class ChildClass extends React.PureComponent<Props, ComponentState> {
			public static getDerivedStateFromError(error: Error): ComponentState {
				// eslint-disable-next-line no-console
				console.log('ErrorBoundary:', error)
				return { hasError: true }
			}
			public constructor(props: Props) {
				super(props)
				this.state = {
					hasError: false,
				}
			}
			public componentDidCatch(error: Error, info: React.ErrorInfo): void {
				// eslint-disable-next-line no-console
				console.log('ErrorBoundary:', error, info)
				this.setState({ hasError: true, error }) // eslint-disable-line react/no-unused-state
			}

			public render(): JSX.Element {
				const { hasError } = this.state
				if (hasError) {
					if (errorMessage)
						return (
							<WrapperStyled>
								<Indent>{errorMessage}</Indent>
							</WrapperStyled>
						)
					return (
						<WrapperStyled>
							<Heading type="h6">Что-то пошло не так ... </Heading>
							<Text type={TextType.CAPTION}>
								Необходимо обновить страницу браузера со сбросом КЭШа (Ctrl + R) <br />
								Если проблема не исчезла, обратитесь в техническую поддержку
								<a href="mailto:support@dasreda.ru"> support@dasreda.ru</a>
							</Text>
						</WrapperStyled>
					)
				}
				return <WrappedComponent {...this.props} />
			}
		}
